import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useHasSubscription = () => {
	const { userTags, isLoading } = useUserTags();
	const hasSubscription = userTags.includes(tags.subscription);

	return [hasSubscription, isLoading];
};
